<template>
    <div class="tab-pane p-20 active">
        <h4 class="header-title m-0 text-dark"><i class="fa-fw ti-star m-r-10"></i>{{ $t('preferences') }}</h4>
        <hr>
        <form class="form-horizontal" @submit.prevent="update()">
            <div class="form-group">
                <div class="col-md-12" :class="{'has-error': errors['default_language']}">
                    <label>{{ $t('default_language') }}</label>
                    <pml-select v-model="record.default_language" :options="languages"></pml-select>
                    <span class="error" v-if="errors['default_language']">{{ errors['default_language'][0] }}</span>
                </div>
            </div>
            <label class="m-b-10">{{ $t('notifications') }}</label>
            <div class="form-group">
                <div class="col-md-12" :class="{'has-error': errors['accept_email_morning_update']}">
                    <pml-checkbox v-model="record.accept_email_morning_update" :label="$t('accept_email_morning_update')"></pml-checkbox>
                    <span class="error" v-if="errors['accept_email_morning_update']">{{ errors['accept_email_morning_update'][0] }}</span>
                </div>
            </div>
            <div class="form-group">
                <div class="col-md-12" :class="{'has-error': errors['accept_email_task_reminder']}">
                    <pml-checkbox v-model="record.accept_email_task_reminder" :label="$t('accept_email_task_reminder')"></pml-checkbox>
                    <span class="error" v-if="errors['accept_email_task_reminder']">{{ errors['accept_email_task_reminder'][0] }}</span>
                </div>
            </div>
            <div class="form-group">
                <div class="col-md-12" :class="{'has-error': errors['accept_email_deal_assignment']}">
                    <pml-checkbox v-model="record.accept_email_deal_assignment" :label="$t('accept_email_deal_assignment')"></pml-checkbox>
                    <span class="error" v-if="errors['accept_email_deal_assignment']">{{ errors['accept_email_deal_assignment'][0] }}</span>
                </div>
            </div>
            <div class="form-group">
                <div class="col-md-12" :class="{'has-error': errors['accept_email_tips']}">
                    <pml-checkbox v-model="record.accept_email_tips" :label="$t('accept_email_tips')"></pml-checkbox>
                    <span class="error" v-if="errors['accept_email_tips']">{{ errors['accept_email_tips'][0] }}</span>
                </div>
            </div>
            <hr class="m-t-5">
            <div class="clearfix">
                <span class="btn btn-white" @click.prevent="cancel()">{{ $t('cancel') }}</span>
                <button class="btn btn-default pull-right" type="submit" v-pml-block="isSaving">{{ $t('update') }}</button>
            </div>
        </form>
    </div>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { preferencesUpdate } from 'services/profile'
    import { mapGetters } from 'vuex'
    import { cloneDeep } from 'lodash'

    export default {
        name: 'Preferences',
        data () {
            return {
                record: {},
                errors: [],
                isSaving: false
            }
        },
        metaInfo () {
            return {
                title: trans('profile') + ' | ' + trans('preferences')
            }
        },
        computed: {
            ...mapGetters({
                preferences: 'getMemberPreferences',
                languages: 'getLanguages'
            })
        },
        mounted () {
            this.record = cloneDeep(this.preferences)
        },
        methods: {
            update () {
                this.isSaving = true

                preferencesUpdate(this.record)
                    .then(() => {
                        Notify.success(trans('_notifications.success'))
                        this.errors = []
                    })
                    .catch(error => { this.errors = error.response.data.errors || [] })
                    .then(() => { this.isSaving = false })
            },
            cancel () {
                this.record = cloneDeep(this.preferences)
                this.errors = []
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/profile/components/Preferences.vue